import { useEffect, useState, type SetStateAction } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { VolumesGeneralFilters } from "../Volumes/VolumesGeneralFilters";
import { MaterialsRevenue } from "../../components/charts/MaterialsRevenue.chart";
import { DroppieRevenuePerMaterial } from "../../components/charts/DroppieRevenuePerMaterial.chart";
import { ParcelRevenuePerCourier } from "../../components/charts/ParcelRevenuePerCourier.chart";
import { ParcelRevenuePerStorePerCourier } from "../../components/charts/ParcelRevenuePerStorePerCourier.chart";
import { PayoutToCustomer } from "../../components/charts/PayoutToCustomer";
import { RevenueMargins } from "../../components/charts/RevenueMargins.chart";
import { AveragePricePerParcel } from "../../components/charts/AveragePricePerParcel.chart";

const RevenuesScreen = () => {
  /** State */
  const [filterType, setFilterType] = useState<"location" | "city">("location");
  const [filterPlaces, setFilterPlaces] = useState<string[]>([]);
  const [sequenceStep, setSequenceStep] = useState(0);

  /** When general filter changes, run chart fetches in sequence (step 0 → 1 → …) */
  useEffect(() => {
    setSequenceStep(0);
  }, [filterType, filterPlaces]);

  /** Reset sequence synchronously when user changes filter type so charts see step=0 on first render */
  const setFilterTypeWithReset = (v: SetStateAction<"location" | "city">) => {
    setSequenceStep(0);
    setFilterType(v);
  };

  return (
    <div>
      <VolumesGeneralFilters
        filterType={filterType}
        setFilterType={setFilterTypeWithReset}
        filterPlaces={filterPlaces}
        setFilterPlaces={setFilterPlaces}
      />
      <MaterialsRevenue
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={0}
      />
      <DroppieRevenuePerMaterial
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={1}
      />
      <PayoutToCustomer
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={2}
      />
      <RevenueMargins
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={3}
      />
      <ParcelRevenuePerCourier
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={4}
      />
      {/* <ParcelRevenue
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={5}
      /> */}
      <ParcelRevenuePerStorePerCourier
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={5}
      />
      <div className="mt-4 mb-6 border-b border-dashed border-[#FF6E41]" />

      <AveragePricePerParcel
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={6}
      />
    </div>
  );
};

export default withProtectedRoute(RevenuesScreen);
